// extracted by mini-css-extract-plugin
export default {"addProduct":"AddProduct_addProduct__HYGWO","container":"AddProduct_container__JIhdR"};